import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Icon, { NAMES } from '@ifit/react-icons';
import { BottomSheet } from 'material-ui-bottom-sheet';
import MuiRaisedButton from 'material-ui/RaisedButton';
import { Navigation } from '../../../../navigation/react-redux-nav';
import { mountainMeadows } from '../../../../theme/colors';
import styles from '../../../../shared-styles';
import './index.css';

export class SuccessModalComponent extends Component {
  continue = () => {
    this.props.continue();
  };

  render() {
    return (
      <div className="success-modal-component">
        <BottomSheet
          open={ this.props.open }
          onRequestClose={ this.continue }
          bodyStyle={ styles.bottomSheetBody }
        >
          <div className="content">
            <Icon
              className="check-icon"
              name={ NAMES.CIRCLE_CHECK }
              color={ mountainMeadows }
              size={ 56 }
              unitSize="px"
            />
            <p>Yay! You've just redeemed your 1-year iFit Coach Family Plan.</p>
            <MuiRaisedButton
              className="account-button"
              label="Continue"
              primary={ true }
              fullWidth={ true }
              style={ styles.buttonStyle }
              labelStyle={ styles.buttonLabelStyle }
              onClick={ this.continue }
            />
          </div>
        </BottomSheet>
      </div>
    );
  }
}

SuccessModalComponent.propTypes = {
  open: PropTypes.bool,
  continue: PropTypes.func.isRequired
};

export default connect(
  null,
  dispatch => ({
    continue: () => dispatch(Navigation.forward())
  })
)(SuccessModalComponent);
